import { React } from 'uweb'
import { MapView } from 'uweb/maptalks'
import { KeyValue } from 'utils/web'

const { useEffect, useState, useRef } = React

const carto_key = `cb1_34mx_1_4ca80bcd1d89e8162f7f6b1f`
const types = {
    'light': `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=${carto_key}`,
    'dark': `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png?key=${carto_key}`,
    'voyager': `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=${carto_key}`,
}

export const mapHook = ({ containerId, isDarkMode, conf }: {
    containerId: string,
    isDarkMode: boolean,
    conf: any,
}): [boolean, MapView] => {

    const [isReady, setReady] = useState(false)
    const ref: any = useRef(null)

    useEffect(() => {

        const lowReso = document.documentElement.clientWidth < 1024

        const useLastView = KeyValue('Last View') === 'true'
        const view = useLastView ? JSON.parse(KeyValue('Last View data') ?? '{}') : {}

        ref.current = new MapView({
            lat: 43.67338010130343, lon: 105.52008346330428,
            zoom: 18,
            minZoom: 12,
            maxZoom: 30,
            devicePixelRatio: 1,
            containerId,
            simulate: false,
            doubleClickZoom: lowReso,
            fps: 60,
            custom: {
                centerCross: true,
                ...view,
            },
            ...conf,
        })

        ref.current.onReady(() => setReady(true))

    }, [])

    useEffect(() => {

        if (ref.current.map && ref.current.map.VERSION) {

            const layer = ref.current.map.getLayer('base')
            if (KeyValue('Base tile') === 'true') layer.config('urlTemplate', isDarkMode ? types.dark : types.light)
            else layer.config('urlTemplate', '#')
            layer.forceReload()

        }

    }, [isDarkMode, isReady])

    return [isReady, ref.current]

}